export const useBrazeGenericDeepLinkingEvent = () => {};
